
<pbir-visual-style-editor [busy]="busy()" [visual]="visual()">
  <ng-container appearanceAfter>
    <ng-content select="[appearanceAfter]"></ng-content>
  </ng-container>

  <ng-container styleAfter>
    <visual-editor-box appearance="fields" canCollapse [hidden]="noXAxis && noYAxis">
      <span boxTitle>
        <i class="fas fa-text-size w-16 text-center mr-5"></i>
        <span>Axis Labels</span>
      </span>
      <div>
        <visual-title-style-editor [(style)]="axisLabels" (styleChange)="axisLabelsModified.set(true)" [fontSizeLabel]="'Size'">
          <ng-container textBefore>
          </ng-container>
        </visual-title-style-editor>
      </div>
    </visual-editor-box>

    <visual-editor-box appearance="fields" canCollapse [hidden]="noXAxis">
      <span boxTitle>
        <i class="fas fa-text-size w-16 text-center mr-5"></i>
        <span>X Axis</span>
      </span>
      <div>
        <visual-title-style-editor [(style)]="xAxis" (styleChange)="xAxisModified.set(true)" [fontSizeLabel]="'Size'">
          <ng-container textBefore>
          </ng-container>
        </visual-title-style-editor>
      </div>
    </visual-editor-box>

    <visual-editor-box appearance="fields" canCollapse [hidden]="noYAxis">
      <span boxTitle>
        <i class="fas fa-text-size w-16 text-center mr-5"></i>
        <span>Y Axis</span>
      </span>
      <div>
        <visual-title-style-editor [(style)]="yAxis" (styleChange)="yAxisModified.set(true)" [fontSizeLabel]="'Size'">
          <ng-container textBefore>
          </ng-container>
        </visual-title-style-editor>
      </div>
    </visual-editor-box>

    <visual-editor-box appearance="fields" canCollapse [hidden]="noLegend">
      <span boxTitle>
        <i class="far fa-info-circle w-16 text-center mr-5"></i>
        <span>Legend</span>
      </span>
      <div>
        <visual-title-style-editor [(style)]="legend" (styleChange)="legendModified.set(true)">
          <ng-container textBefore>
            <label>Position:</label>
            <mat-select class="trg-outline user-select-none" panelClass="trg-outline-dropdown"
                        [disabled]="busy()"
                        [ngModel]="legendPosition()"
                        (ngModelChange)="setLegendPosition($event)">
              @for (i of LegendPositions; track i.id) {
              <mat-option [value]="i">{{i.title}}</mat-option>
              }
            </mat-select>
          </ng-container>
        </visual-title-style-editor>
      </div>
    </visual-editor-box>

    <visual-editor-box appearance="fields" canCollapse [hidden]="noDataLabels">
      <span boxTitle>
        <i class="fas fa-tag w-16 text-center mr-5"></i>
        <span>Data Labels</span>
      </span>
      <div>
        <visual-title-style-editor [(style)]="dataLabels" (styleChange)="dataLabelsModified.set(true)">
          <ng-container textBefore>
            <label>Background:</label>
            <app-color-input [value]="dataLabelsBackgroundColor()"
                             (valueChange)="setDataLabelsBackgroundColor($event)"></app-color-input>
          </ng-container>
          <ng-container textAfter>
            <label>Number Format:</label>
            <mat-select class="trg-outline user-select-none" panelClass="trg-outline-dropdown"
                        [disabled]="busy()"
                        [ngModel]="dataLabelsNumberFormat()"
                        (ngModelChange)="setDataLabelsNumberFormat($event)">
              @for (nf of NumberFormats(); track nf.id) {
              <mat-option [value]="nf.id">{{nf.title}}</mat-option>
              }
            </mat-select>
          </ng-container>
        </visual-title-style-editor>
      </div>
    </visual-editor-box>
  </ng-container>
</pbir-visual-style-editor>